import React from "react";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { DonateSection } from "@/components/sections/DonateSection";
import { ImpactCalculator } from "@/components/sections/ImpactCalculator";
import { TransparencyStrip } from "@/components/sections/TransparencyStrip";
import { FAQSection } from "@/components/sections/FAQSection";
import { SEO } from "@/lib/seo";

export default function DonatePage() {
  return (
    <main>
      <SEO title="Donate" description="Choose your amount, method and cause. Every donation is receipted and audited." breadcrumbs={[{name:"Home",href:"/"},{name:"Donate",href:"/donate"}]} />
      <PageHeader eyebrow="Donate" title="Support the work. Transparently." lead="Choose your amount, method and cause. Every donation is receipted and audited." />
      <ImpactCalculator />
      <DonateSection />
      <TransparencyStrip />
      <FAQSection />
    </main>
  );
}
